import getAttribute from './getAttribute';
import getBadge, { getFirstValidBadge } from './getBadges';
import { getGenderFromAttributes } from './getGender';
import getPrice from './getPrice';
import getProductAvailability from './getProductAvailability';
import getProductImage from './getProductImage';
import getProductLinkByPartNumber from './getProductLinkByPartNumber';

export default function getMappedProduct({
    availableImageSizes,
    badgeBlocklist,
    consideredBadge,
    id,
    imageQuality,
    imagesphereAspectRatio,
    locale,
    messages,
    pageType,
    pdpUrlTemplate,
    plpImageSrcSet,
    product = {},
    saleBadges,
    user,
}) {
    const {
        attributes = [],
        badges,
        designerIdentifier = '',
        designerName = '',
        designerNameEN = '',
        masterCategory = {},
        name,
        nameEN,
        onSale = false,
        partNumber,
        preOrder = false,
        price,
        productColours = [],
        seo,
        shortDescription,
        tracking = {},
    } = product;

    const {
        categoryId: primaryCategoryId = '',
        child: {
            categoryId: subCategory1Id = '',
            child: { categoryId: subCategory2Id = '', label: subCategory2 = '', labelEN: subCategory2EN = '' } = {},
            label: subCategory1 = '',
            labelEN: subCategory1EN = '',
        } = {},
        label: primaryCategory = '',
        labelEN: primaryCategoryEN = '',
    } = masterCategory || {};

    const analyticsAttributes = {
        season: getAttribute(attributes, 'Sale Season'),
        department: getAttribute(attributes, 'Department'),
        colour: getAttribute(attributes, 'Brand Colour'),
        badge: getFirstValidBadge(badges, badgeBlocklist),
        nameEN: nameEN || tracking?.name, // nameEN for PLP and tracking?.name for PDP
        designerNameEN,
        preOrder,
        category: {
            primaryCategory: primaryCategoryEN || primaryCategory,
            subCategory1: subCategory1EN || subCategory1,
            subCategory2: subCategory2EN || subCategory2,
            ids: [primaryCategoryId, subCategory1Id, subCategory2Id],
        },
        gender: getGenderFromAttributes(attributes),
    };

    const selectedProductColour = productColours?.find((c) => c.selected) || productColours?.[0] || product;
    const productSeo = selectedProductColour?.seo || seo;
    const badge =
        getBadge({
            badges,
            badgeBlocklist,
            pageType,
            messages,
            options: { onSale, configSaleBadges: saleBadges },
            user,
            segmentBadges: selectedProductColour?.segmentBadges,
        }) || null;
    const availability = getProductAvailability(product);
    const priceWithAvailability = { availability, ...getPrice(price, 'rdSellingPrice') };

    return {
        productId: id,
        designerName: designerNameEN || designerName,
        designerIdentifier,
        name: shortDescription || name || nameEN,
        price: priceWithAvailability,
        onSale,
        badge,
        imgSrc: getProductImage(product, availableImageSizes, imageQuality, 0, imagesphereAspectRatio, plpImageSrcSet),
        href: getProductLinkByPartNumber(pdpUrlTemplate, locale, productSeo, selectedProductColour?.partNumber),
        partNumber,
        masterCategory,
        analyticsAttributes,
        consideredBadge,
        hasSiblings: product.hasSiblings,
        productSiblings: product.productSiblings,
        modelId: product.modelId,
        notStockedOnline: !!product.notStockedOnline,
        colour: selectedProductColour?.label,
    };
}
